import { Empty } from "ant-design-vue";
// import NewTable from "./src/YwTable.vue";
import YwEmpty from "./src/YwEmpty.vue";
import "./src/empty.less"
// import "./src/table.less"
// const { Column, ColumnGroup, ...other } = Table;
YwEmpty.install = function (Vue) {
    Vue.use(Empty)
    Vue.component(YwEmpty.name, YwEmpty);
};
export default YwEmpty;
